import React from 'react';
import { Icon } from './Icon.js';
export const IconSquareKanban = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m14,2H6c-2.206,0-4,1.794-4,4v8c0,2.206,1.794,4,4,4h8c2.206,0,4-1.794,4-4V6c0-2.206-1.794-4-4-4Zm-5,12c0,.553-.447,1-1,1h-2c-.553,0-1-.447-1-1V6c0-.553.447-1,1-1h2c.553,0,1,.447,1,1v8Zm6-5c0,.553-.447,1-1,1h-2c-.553,0-1-.447-1-1v-3c0-.553.447-1,1-1h2c.553,0,1,.447,1,1v3Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconSquareKanban.js.map